import { render, staticRenderFns } from "./displayImg.vue?vue&type=template&id=70032b8e"
import script from "./displayImg.vue?vue&type=script&lang=js"
export * from "./displayImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports